import { Route } from "react-router-dom";
import NewDashboard from "../features/new_dashboard";

/* DASHBOARD */
export const dashboardRoutes = (
    <Route path="/dashboard" element={<NewDashboard />} key="dashboard" />
);
